import { useEffect } from 'react';
import { disclosureActions } from 'actions';
import { useRedux } from './';

const useDisclosure = (personalLoanUuid, disclosurelistUuid, load = true) => {
  const disclosureReducerAndActions = useRedux('disclosureReducer', disclosureActions);
  const { disclosuresByApplicationUuid, getApplicationDisclosures } = disclosureReducerAndActions;
  const disclosuresList = disclosuresByApplicationUuid[personalLoanUuid]?.disclosuresList || [];

  useEffect(() => {
    if (personalLoanUuid && disclosurelistUuid && load) getApplicationDisclosures(personalLoanUuid, disclosurelistUuid);
  }, [personalLoanUuid, disclosurelistUuid, load, getApplicationDisclosures]);

  return {
    disclosuresList,
    ...disclosureReducerAndActions,
  };
};

export default useDisclosure;
